<template v-if="pageLoader.loading.value">
    <div class="dashboard">
        <dashboard-sidebar />
        <div class="dashboard__content">
            <form class="form">
                <div class="row m-0">
                    <h3 class="h3"><i18n-t keypath="dashboard.mySettings" /></h3>
                    <p class="settings__subtitle">
                        {{ text }}
                    </p>
                </div>

                <div class="row m-0 settings__filters">
                    <div class="col-12">
                        <h4 class="h4">
                            <i18n-t keypath="dashboard.settings.your" />
                            4
                            <i18n-t keypath="dashboard.settings.mainFilters" />
                        </h4>
                    </div>
                    <main-filter-item
                        :filter="mainFilter1"
                        :options="mainFilter1Options"
                        :modelValue="mainFilter1Model"
                        :class="{ 'app-drop-zone-active': !!activeDragFilter }"
                        @update:modelValue="updateMainFilter1"
                        @drop="(event) => onMainFilterDrop('mainFilter1', event)"
                        @dragover.prevent
                        @drag="(event) => onFilterDrag(mainFilter1, event)"
                        @dragend="(event) => onFilterDragEnd(mainFilter1, event)"
                    />
                    <main-filter-item
                        :filter="mainFilter2"
                        :options="mainFilter2Options"
                        :modelValue="mainFilter2Model"
                        :class="{ 'app-drop-zone-active': !!activeDragFilter }"
                        @update:modelValue="updateMainFilter2"
                        @drop="(event) => onMainFilterDrop('mainFilter2', event)"
                        @dragover.prevent
                        @drag="(event) => onFilterDrag(mainFilter2, event)"
                        @dragend="(event) => onFilterDragEnd(mainFilter2, event)"
                    />
                    <main-filter-item
                        :filter="mainFilter3"
                        :options="mainFilter3Options"
                        :modelValue="mainFilter3Model"
                        :class="{ 'app-drop-zone-active': !!activeDragFilter }"
                        @update:modelValue="updateMainFilter3"
                        @drop="(event) => onMainFilterDrop('mainFilter3', event)"
                        @dragover.prevent
                        @drag="(event) => onFilterDrag(mainFilter3, event)"
                        @dragend="(event) => onFilterDragEnd(mainFilter3, event)"
                    />
                    <main-filter-item
                        :filter="mainFilter4"
                        :options="mainFilter4Options"
                        :modelValue="mainFilter4Model"
                        :class="{ 'app-drop-zone-active': !!activeDragFilter }"
                        @update:modelValue="updateMainFilter4"
                        @drop="(event) => onMainFilterDrop('mainFilter4', event)"
                        @dragover.prevent
                        @drag="(event) => onFilterDrag(mainFilter4, event)"
                        @dragend="(event) => onFilterDragEnd(mainFilter4, event)"
                    />
                </div>
                <div
                    class="row m-0 settings__select-filter"
                    :class="{
                        'app-drop-zone-active':
                            activeDragFilter && !showFilter[activeDragFilter],
                    }"
                    @drop="onFiltersBlockDrop"
                    @dragover="onFiltersBlockDragOver"
                >
                    <div class="col-12">
                        <h4 class="h4">
                            <i18n-t
                                keypath="dashboard.settings.availableFiltersForSelection"
                            />
                        </h4>
                    </div>

                    <app-check-box-list
                        v-if="showFilter['promotion']"
                        v-model="quickSelectionModel"
                        :options="filtersDto.quickSelection"
                        type="quickSelection"
                        @drag="(event) => onFilterDrag('quickSelection', event)"
                        @dragend="(event) => onFilterDragEnd('quickSelection', event)"
                    />

                    <app-check-box-list
                        v-if="showFilter['gearbox']"
                        v-model="gearsModel"
                        :options="filtersDto.gears"
                        type="gears"
                        @drag="(event) => onFilterDrag('gears', event)"
                        @dragend="(event) => onFilterDragEnd('gears', event)"
                    />

                    <app-check-box-list
                        v-if="showFilter['options']"
                        v-model="equipmentDetailsModel"
                        :options="filtersDto.equipmentDetails"
                        type="equipmentDetails"
                        @drag="(event) => onFilterDrag('equipmentDetails', event)"
                        @dragend="(event) => onFilterDragEnd('equipmentDetails', event)"
                    />

                    <app-check-box-list
                        v-if="showFilter['condition']"
                        v-model="conditionModel"
                        :options="filtersDto.type"
                        type="type"
                        @drag="(event) => onFilterDrag('type', event)"
                        @dragend="(event) => onFilterDragEnd('type', event)"
                    />

                    <app-check-box-list
                        v-if="showFilter['brand']"
                        v-model="brandModel"
                        :options="filtersDto.brand"
                        type="brand"
                        @drag="(event) => onFilterDrag('brand', event)"
                        @dragend="(event) => onFilterDragEnd('brand', event)"
                    />

                    <app-check-box-list
                        v-if="showFilter['model']"
                        v-model="modelModel"
                        :options="filtersDto.model"
                        type="model"
                        @drag="(event) => onFilterDrag('model', event)"
                        @dragend="(event) => onFilterDragEnd('model', event)"
                    />

                    <app-check-box-list
                        v-if="showFilter['fueltype']"
                        v-model="fuelTypeModel"
                        :options="filtersDto.fuelType"
                        type="fuelType"
                        @drag="(event) => onFilterDrag('fuelType', event)"
                        @dragend="(event) => onFilterDragEnd('fuelType', event)"
                    />

                    <range-slider
                        v-if="showFilter['firstregistrationYear']"
                        v-model="yearModel"
                        :options="filtersDto.year"
                        type="year"
                        @drag="(event) => onFilterDrag('year', event)"
                        @dragend="(event) => onFilterDragEnd('year', event)"
                    />

                    <range-slider
                        v-if="showFilter['emissionNedc']"
                        v-model="emissionModel"
                        :options="filtersDto.emission"
                        type="emission"
                        @drag="(event) => onFilterDrag('emission', event)"
                        @dragend="(event) => onFilterDragEnd('emission', event)"
                    />

                    <range-slider
                        v-if="showFilter['damage']"
                        v-model="damageAmountModel"
                        :options="filtersDto.damageAmount"
                        type="damageAmount"
                        @drag="(event) => onFilterDrag('damageAmount', event)"
                        @dragend="(event) => onFilterDragEnd('damageAmount', event)"
                    />

                    <range-slider
                        v-if="showFilter['mileage']"
                        v-model="mileageModel"
                        :options="filtersDto.mileage"
                        type="mileage"
                        @drag="(event) => onFilterDrag('mileage', event)"
                        @dragend="(event) => onFilterDragEnd('mileage', event)"
                    />

                    <app-check-box-list
                        v-if="showFilter['availability']"
                        v-model="availabilityModel"
                        :options="filtersDto.availability"
                        type="availability"
                        @drag="(event) => onFilterDrag('availability', event)"
                        @dragend="(event) => onFilterDragEnd('availability', event)"
                    />

                    <color-filter
                        v-if="showFilter['color']"
                        v-model="colorsModel"
                        :options="filtersDto.colors"
                        @drag="(event) => onFilterDrag('colors', event)"
                        @dragend="(event) => onFilterDragEnd('colors', event)"
                    />

                    <div class="col-12">
                        <button
                            class="button btn-success"
                            v-on:click.prevent="handleSave"
                        >
                            <i18n-t keypath="dashboard.settings.saveBtn" />
                            <span
                                v-if="isLoading"
                                style="
                                    margin-left: 10px;
                                    margin-top: 1px;
                                    position: absolute;
                                "
                                class="p-button-loading-icon pi pi-spinner pi-spin"
                            ></span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script lang="ts">
import { MySettings } from "@/dashboard/my-settings/my-settings.ts";
export default MySettings;
</script>

<style scoped></style>
